import React from 'react'
import Projects from '../components/Projects'

function ProjectsComp() {
  return (
<>

<Projects/>
</>  )
}

export default ProjectsComp